import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=37378d64&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=37378d64&prod&lang=scss&scoped=true&"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=37378d64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37378d64",
  null
  
)

export default component.exports